/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useMutation } from '@apollo/client';

export const useConfirmDasAccount = () => {

    const CONFIRM_DAS_ACCOUNT_GQL = gql`
    mutation ConfirmDasAccount($confirmDasRequest: ConfirmDasAccountInput!) {
        confirmDasAccount(confirmDasRequest: $confirmDasRequest) {
            accountNumber
            branchNum
            emailAddress
            languagePreference
        }
    }`;

  const [confirmDasAccount] = useMutation(CONFIRM_DAS_ACCOUNT_GQL);

    return {
        confirmDasAccount: async ({confirmDasRequest}) => {
          return confirmDasAccount({ variables: { confirmDasRequest ,
             context:{
            clientName:"/secure-storage/manage"
        }
          } });
        }
    }
}